export default "__VITE_ASSET__CBcz2IeG__"